<template>
  <div class="card-detail">
    <div>
      <signature-banner
        v-if="signature"
        :signature="signature"
        :can-discard="false"
        :can-retry="canSignDocument"
        :running-description="runningDescription"
        @retry="signModal.show = true"
      />
    </div>
    <div class="card-detail-data">
      <div v-html="document.data" />
      <div class="document-detail-actions">
        <st-button-report
          v-if="isSigned"
          type="pdf"
          button-class="btn-primary"
          label="Imprimir impresso assinado"
          :icon="['fal', 'file-signature']"
          :options="null"
          :route="printRoute"
        ></st-button-report>
        <template v-else>
          <st-button-report
            type="pdf"
            button-class="btn-info"
            :disabled="isSignatureRunning"
            :route="printRoute"
          >
            <template v-slot:default="{ icon, option }">
              <fa-icon :icon="icon"></fa-icon>
              <span v-if="option">{{ option.text }}</span>
            </template>
          </st-button-report>
          <button
            v-if="canSignDocument && !signature"
            type="button"
            class="btn btn-gray btn-icon btn-icon-left ml-2"
            @click="signModal.show = true"
          ><fa-icon :icon="['fal', 'signature']" /> Assinar</button>
        </template>
      </div>
    </div>
    <document-sign-modal
      v-if="signModal.show"
      :show="signModal.show"
      :kind="signature ? signature.kind : ''"
      @sign="signDocument"
      @close="signModal.show = false"
    />
  </div>
</template>

<script>
import digitalSignatureMixin from '@/mixins/digital-signature';
import SignatureBanner from '@/components/digital-signature/SignatureBanner.vue';
import DocumentSignModal from '@/components/digital-signature/DocumentSignModal.vue';
import { MEDICAL_RECORD_DOCUMENT } from '@/data/digital-signature';

export default {
  mixins: [digitalSignatureMixin],
  digitalSignatureRealtime: false,
  components: {
    SignatureBanner,
    DocumentSignModal,
  },
  props: {
    medicalRecordId: {
      type: String,
      required: true,
    },
    document: {
      type: Object,
      required: true,
    },
    canSign: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      runningDescription: 'O impresso assinado fica disponível para impressão assim que o Bird ID concluir.',
      signModal: {
        show: false,
      },
    };
  },
  created() {
    this.signature = this.document.digitalSignature || null;
  },
  watch: {
    'document.digitalSignature': function syncFromDocument(value) {
      this.signature = value || null;
    },
    signature(value) {
      if (this.document.digitalSignature !== value) {
        this.$set(this.document, 'digitalSignature', value);
      }
    },
  },
  computed: {
    printRoute() {
      return `/medical-records/${this.medicalRecordId}/documents/${this.document.id}/print`;
    },
    canSignDocument() {
      return this.canSign && this.isDigitalSignatureEnabled && !!this.document.data;
    },
  },
  methods: {
    isOwnDigitalSignature(data) {
      return data.type === MEDICAL_RECORD_DOCUMENT && data.itemId === this.document.id;
    },
    signDocument({ kind, pageSize }) {
      this.requestDigitalSignature(this.medicalRecordId, {
        type: MEDICAL_RECORD_DOCUMENT,
        itemId: this.document.id,
        kind,
        pageSize,
      }, () => {
        this.signModal.show = false;
      });
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.document-detail-actions {
  align-items: center;
  display: flex;
  margin-top: $layout-spacing;
}
</style>
